// ** React Imports
import React, { Fragment, useState, useEffect, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Stepper from '@mui/material/Stepper'
import MenuItem from '@mui/material/MenuItem'
import Checkbox from '@mui/material/Checkbox'
import ListItemText from '@mui/material/ListItemText'
import StepLabel from '@mui/material/StepLabel'
import Typography from '@mui/material/Typography'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton'
import CardContent from '@mui/material/CardContent'
import { styled } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import MuiStep from '@mui/material/Step'
import InputAdornment from '@mui/material/InputAdornment'
import IgnoreIcon from '@mui/icons-material/VisibilityOff'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CardHeader from '@mui/material/CardHeader'
import { DataGrid } from '@mui/x-data-grid'
import { DataGridPro } from '@mui/x-data-grid-pro';
import { TextField, Select, FormControl, InputLabel } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import ListSubheader from '@mui/material/ListSubheader'
import ServerSideToolbar from '../../components/data-grid/ServerSideToolbar'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';

import Swal from 'sweetalert2';
// Define the styles for the invalid email cell

// ** Third Party Imports

// ** Icon Imports

import Icon from "../../components/icon";

// ** Custom Components Imports
import StepperCustomDot from '../../components/mui/StepperCustomDot'
import CustomTextField from '../../components/mui/text-field'
import CustomChip from '../../components/mui/chip'
// import ServerSideToolbar_WithoutSearch from '../../components/data-grid/ServerSideToolbar_WithoutSearch'

// ** Hook Import
import { useSettings } from '../../components/hooks/useSettings'

// ** Util Import
import { getInitials } from '../../components/utils/get-initials'

// ** Styled Component
import StepperWrapper from '../../components/styles/mui/stepper'

// ** Layout Import
import BlankLayout from '../Layout/blankLayout'

import ClearIcon from '@mui/icons-material/Clear';
import { dev_baseUrl } from 'utils/var'


const steps = [
    {
        title: 'Map Columns'
    },
    {
        title: 'Fix Errors'
    }
]

const Step = styled(MuiStep)(({ theme }) => ({
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    '&:first-of-type': {
        paddingLeft: 0
    },
    '&:last-of-type': {
        paddingRight: 0
    },
    '& .MuiStepLabel-iconContainer': {
        display: 'none'
    },
    '& .step-subtitle': {
        color: `${theme.palette.text.disabled} !important`
    },
    '& + svg': {
        color: theme.palette.text.disabled
    },
    '&.Mui-completed .step-title': {
        color: theme.palette.text.disabled
    },
    '&.Mui-completed + svg': {
        color: theme.palette.primary.main
    },
    [theme.breakpoints.down('md')]: {
        padding: 0,
        ':not(:last-of-type)': {
            marginBottom: theme.spacing(6)
        }
    }
}))

const EmployeeBulkImport = () => {

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('jwtToken');
        if (!token) {
            navigate('/login', { state: { message: 'Please login to continue.' } }); // Redirect to login if token is not found
        } else {
            setIsLoading(false); // Set loading to false if token is found
        }
    }, [navigate]);

    const location = useLocation();
    const fileData = location.state?.data || [];

    const columnNamesFromFile = fileData.length > 0 
  ? Object.keys(fileData[0]).filter(columnName => {

      return fileData.some(row => row[columnName] && row[columnName].toString().trim() !== '');
    }) 
  : [];

    const predefinedFields = ['First Name', 'Last Name', 'Email', 'Phone'];
    const additionalFields = [
        'Role', 'Status', 'Date of Birth', 'Referred By', 'Address', 'City', 'State/Province',
        'Postal Code', 'Country', 'Emergency Contact Name', 'Emergency Contact Relationship',
        'Emergency Contact Phone Number', 'Hire Date', 'Employment Status', 'Departments',
        'Job Title', 'Probation End Date', 'Driving license','Driving license expiry', 'Employee Wages Amount',
        'Employee Wages Type', 'Availability', 'Clock in / out'
    ];

    const fieldsToRender = [...predefinedFields, ...additionalFields];

    const getDefaultValues = () => {
      const initialValues = {};
      columnNamesFromFile.forEach((columnName) => {
        initialValues[columnName] = fieldsToRender.includes(columnName)
          ? columnName
          : fieldsToRender.some(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase())
            ? fieldsToRender.find(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase())
            : 'select';
      });
      return initialValues;
    };

    // ** States
    const [activeStep, setActiveStep] = useState(0)
    const [total, setTotal] = useState(0)
    const [sort, setSort] = useState('asc')
    const [searchValue, setSearchValue] = useState('')
    const [sortColumn, setSortColumn] = useState('first_name')
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 7 })
    const [mappingState, setMappingState] = useState({});
    const [selectedValues, setSelectedValues] = useState(getDefaultValues()); 
    const [errorState, setErrorState] = useState({});
    const [myData, setMyData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);    
    const [preLoading, setPreLoading] = useState(true);  
    const [message, setMessage] = useState(location.state?.message || '');
    const [errorMessages, setErrorMessages] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [openErrorListDlg, setOpenErrorListDlg] = useState(false);
    const [openSuccessListDlg, setOpenSuccessListDlg] = useState(false);
    const [successMessages, setSuccessMessages] = useState('');
    const [alertIsDismissed, setAlertIsDismissed] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [displayBanner, setDisplayBanner] = useState(true);

    useEffect(() => {
      const handleBeforeUnload = (e) => {
    
          e.preventDefault(); 
          e.returnValue = ''; 
      };
      window.addEventListener('beforeunload', handleBeforeUnload);
  
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    }, []);

    useEffect(() => {
        const fetchDepartments = async () => {
            const token = localStorage.getItem('jwtToken');
            if (!token) {
                navigate('/login', { state: { message: 'Session expired, please login again.' } });
                return;
            }

            try {
                const response = await fetch(`${dev_baseUrl}/Employee/getdeparments`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch departments.");
                }

                const result = await response.json();
                if (!result.isError) {
                    // Assuming the result contains the department data in the form of key-value pairs
                    setDepartments(result.result.map(dep => ({ key: dep.key, value: dep.value })));
                } else {
                    console.error("Error fetching departments:", result.message);
                }
            } catch (error) {
                console.error("Fetch departments error:", error);
            }
        };

        fetchDepartments();
    }, [navigate]);


    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => {
                setMessage('');
            }, 10000);
            return () => clearTimeout(timer);
        }
    }, [message]);

    function loadServerRows(currentPage, data) {
        return data.slice(currentPage * paginationModel.pageSize, (currentPage + 1) * paginationModel.pageSize);
    }

    const fetchTableData = useCallback(
        async (sort, q, column) => {
            let filteredData = [...myData];

            if (q) {
                filteredData = filteredData.filter(row =>
                    Object.values(row).some(value =>
                        value.toString().toLowerCase().includes(q.toLowerCase())
                    )
                );
            }
            if (sort && column) {
                filteredData = filteredData.sort((a, b) => {
                    if (a[column] < b[column]) return sort === 'asc' ? -1 : 1;
                    if (a[column] > b[column]) return sort === 'asc' ? 1 : -1;
                    return 0;
                });
            }

            setTotal(filteredData.length);
            setRows(loadServerRows(paginationModel.page, filteredData));
        },
        [paginationModel.page, paginationModel.pageSize, myData, sort, searchValue, sortColumn]

    );
    useEffect(() => {        
        const timer = setTimeout(() => {
            setPreLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        fetchTableData(sort, searchValue, sortColumn)
    }, [fetchTableData, searchValue, sort, sortColumn])

    const handleAlertDismiss = () => {
        setAlertIsDismissed(true);
    }

    const handleSortModel = newModel => {
        if (newModel.length) {
            setSort(newModel[0].sort);
            setSortColumn(newModel[0].field);
            fetchTableData(newModel[0].sort, searchValue, newModel[0].field);
        } else {
            setSort('asc');
            setSortColumn(Object.keys(myData[0])[0]); // Sort by the first key in `mappedData`
        }
    };

    const handleSearch = value => {
        setSearchValue(value);
        fetchTableData(sort, value, sortColumn);
    };

    const employeeWagesType = ['Hourly', 'Salary']
    const employeeStatusOptions = ['Full Time', 'Part Time', 'Contract']
    const statusOptions = ['Active', 'Inactive']
    const rolesOptions = [
        'Office Manager',
        'Operations Manager',
        'Sales Manager',
        'Account Manager',
        'Crew Leader',
        'Field Crew Member'
    ];

    

    const errorColumns = [    
        {
            flex: 0.25,
            minWidth: 180,
            field: 'email',
            headerName: 'Email'
        },
        {
            flex: 0.25,
            minWidth: 180,
            headerName: 'Reason',
            field: 'failureReason'
        }
    ]

    const handleCloseErrorListDlg = () => {        
        sessionStorage.removeItem('myStep');
        sessionStorage.setItem('myStep', 3);
        setOpenErrorListDlg(false);
        navigate('/employees');
    }

    const handleCloseSuccessListDlg = () => {        
        navigate('/employees');
    }

    const excelDateToJSDate = (excelDate) => {
        const serialDate = Number(excelDate);
        const excelStartDate = new Date(Date.UTC(1900, 0, 1));
        const jsDate = new Date(excelStartDate.getTime() + (serialDate - 1) * 24 * 60 * 60 * 1000);

        if (serialDate > 59) {
            jsDate.setUTCDate(jsDate.getUTCDate() - 1);
        }

        return jsDate;
    };

    const parseDateAsUTC = (dateString) => {
      const [month, day, year] = dateString.split('-').map(Number);
      return new Date(Date.UTC(year, month - 1, day)); // Creates a UTC date
    };
    
    const formatDate = (date) => {
      const jsDate = typeof date === 'string' ? parseDateAsUTC(date) : date;
      
      if (isNaN(jsDate.getTime())) {
        return 'Invalid Date';
      }
    
      const month = String(jsDate.getUTCMonth() + 1).padStart(2, '0');
      const day = String(jsDate.getUTCDate()).padStart(2, '0');
      const year = jsDate.getUTCFullYear();
    
      return `${month}-${day}-${year}`;
    };

    // ** Hooks & Var
    const { settings } = useSettings()
    const smallScreen = useMediaQuery(theme => theme.breakpoints.down('md'))
    const { direction } = settings


    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
    

     const updateSelectedValues = () => {
      // Create the new selectedValues object based on mappings
      const newSelectedValues = columnNamesFromFile.reduce((acc, columnName) => {
        if (predefinedFields.includes(columnName)) {
          acc[columnName] = selectedValues[columnName] || columnName;
        }
        return acc;
      }, {});
  
      // Update the state with the new object
      setSelectedValues(newSelectedValues);
    };

    useEffect(() => {
        updateSelectedValues();
    }, []);


    const handleSelectChange = (columnName) => (event) => {
        const newValue = event.target.value;
      
        setSelectedValues((prev) => {
    
          const updatedValues = { ...prev, [columnName]: newValue };
    
          // Re-check for conflicts across all columns
          const newErrorState = {};
          const valueCounts = {};
      
          // Count occurrences of each selected value
          Object.values(updatedValues).forEach((value) => {
            valueCounts[value] = (valueCounts[value] || 0) + 1;
          });
      
          // Identify conflicts and update the error state
          Object.keys(updatedValues).forEach((key) => {
            const value = updatedValues[key];
            if (valueCounts[value] > 1 ) {
              newErrorState[key] = `${value} has already been matched to another column`;
            } 
          });
    
          setErrorState(newErrorState);
      
          return updatedValues;
        });
      };

    const handleConfirmClick = (columnName) => {
  
        const selectedValue = selectedValues[columnName] || (fieldsToRender.includes(columnName) 
        ? columnName 
        : fieldsToRender.some(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
          ? fieldsToRender.find(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
          : 'select');
      
        if (!selectedValue || selectedValue === 'select') {
          setMessage('Please select a valid field before confirming the mapping.');
          return;
        }
      
        setMappingState((prevState) => ({
          ...prevState,
          [columnName]: {
            ...prevState[columnName],
            confirmed: true,
            ignored: false,
            mappedValue: selectedValue || ''
          }
        }));
      };

    const handleIgnoreClick = (columnName) => {
        setMappingState((prevState) => ({
            ...prevState,
            [columnName]: {
                confirmed: false,
                ignored: true,
                mappedValue: '' // Clear the mapped value
            }
        }));
    };

    const handleEditClick = (columnName) => {
        setMappingState((prevState) => ({
            ...prevState,
            [columnName]: {
                confirmed: false,
                ignored: false,
                mappedValue: '' // Reset the mapping
            }
        }));
    }

    const isConfirmDisabled = (columnName) => {
        const selectedValue = selectedValues[columnName] || mappingState[columnName]?.mappedValue || (fieldsToRender.includes(columnName) 
        ? columnName 
        : fieldsToRender.some(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
          ? fieldsToRender.find(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
          : 'select');
        const hasError = Boolean(
          selectedValues[columnName] && Object.values(selectedValues).filter(val => val === selectedValue).length > 1
        );
      
        // Disable if default value is 'select' or if there is an error for the field
        return selectedValue === 'select' || hasError;
      };
    

      const handleBack = () => {

        if (window.confirm("Are you sure you want to go back? Your changes might not be saved.")) {
            
          if (activeStep === 0) {
            navigate('/employees');
          } else {
            setActiveStep(prevActiveStep => prevActiveStep - 1)
          }
        }
      }     
    
    const handleSearchChange = (searchKeyWord) => {
        setSearchText(searchKeyWord);
        if (searchKeyWord === '') {
            setPaginationModel((prevModel) => ({
                ...prevModel,
                page: 0,
            }));
        }
    }

    const handleClearSearch = () => {
        handleSearchChange('');
    };

    const departmentOptions = departments.map(dep => ({
        key: dep.key,
        value: dep.value,
    }));

    const handleNext = async (event) => {

      setMessage('');
    console.log(event.target?.innerText);
    // Move to the next step
    if(event.target?.innerText === 'Complete Import'){
    
    const updatedRows = myData.map((row) => {
      const updatedRow = { ...row };
      let hasError = false;
    
      const invalidNames = [null, '', 'None'];
      if (invalidNames.includes(updatedRow['First Name']) || invalidNames.includes(updatedRow['Last Name'])) {
        hasError = true;
      }
    
      // Validate email
      if (!validateEmail(updatedRow['Email'])) {
        hasError = true;
      }
    
      // Check Role
      if (!rolesOptions.includes(updatedRow['Role'])) {
        updatedRow['Role'] = null;
      }
    
      // Check Employment Status
      if (!employeeStatusOptions.includes(updatedRow['Employment Status'])) {
        updatedRow['Employment Status'] = null;
      }
    
      if (!statusOptions.includes(updatedRow['Status'])) {
        updatedRow['Status'] = null;
      }
    
    // Handle Hire Date
    if (typeof updatedRow['Hire Date'] === 'string') {
      if (isNaN(Date.parse(updatedRow['Hire Date']))) {
        updatedRow['Hire Date'] = '1900-01-01';
      } else {
        // Parse manually entered date in MM-DD-YYYY as UTC
        const parsedDate = parseDateAsUTC(updatedRow['Hire Date']);
        updatedRow['Hire Date'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
      }
    } else if (!isNaN(updatedRow['Hire Date'])) {
      // Handle Excel serial number dates
      const excelDate = updatedRow['Hire Date'];
      const jsDate = excelDateToJSDate(excelDate);
      updatedRow['Hire Date'] = formatDate(jsDate);
    } else {
      // Fallback for Date object or other formats
      const parsedDate = new Date(updatedRow['Hire Date']);
      updatedRow['Hire Date'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
    }
    
    
      // Handle Date of Birth
    if (typeof updatedRow['Date of Birth'] === 'string') {
      if (isNaN(Date.parse(updatedRow['Date of Birth']))) {
        updatedRow['Date of Birth'] = '1900-01-01';
      } else {
        // Parse manually entered date in MM-DD-YYYY as UTC
        const parsedDate = parseDateAsUTC(updatedRow['Date of Birth']);
        updatedRow['Date of Birth'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
      }
    } else if (!isNaN(updatedRow['Date of Birth'])) {
      // Handle Excel serial number dates
      const excelDate = updatedRow['Date of Birth'];
      const jsDate = excelDateToJSDate(excelDate);
      updatedRow['Date of Birth'] = formatDate(jsDate);
    } else {
      // Fallback for Date object or other formats
      const parsedDate = new Date(updatedRow['Date of Birth']);
      updatedRow['Date of Birth'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
    }
    
    
        // Handle Probation End Date
        // if (typeof updatedRow['Probation End Date'] === 'string' && isNaN(Date.parse(updatedRow['Probation End Date']))) {
        //   updatedRow['Probation End Date'] = '1900-01-01';
        // } else if (!isNaN(updatedRow['Probation End Date'])) {
        //   const excelDate = updatedRow['Probation End Date'];
        //   const jsDate = excelDateToJSDate(excelDate);
        //   updatedRow['Probation End Date'] = formatDate(jsDate);
        // } else {
        //   const parsedDate = new Date(updatedRow['Probation End Date']);
        //   updatedRow['Probation End Date'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
        // }
      if (typeof updatedRow['Probation End Date'] === 'string') {
        if (isNaN(Date.parse(updatedRow['Probation End Date']))) {
          updatedRow['Probation End Date'] = '1900-01-01';
        } else {
          // Parse manually entered date in MM-DD-YYYY as UTC
          const parsedDate = parseDateAsUTC(updatedRow['Probation End Date']);
          updatedRow['Probation End Date'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
        }
      } else if (!isNaN(updatedRow['Probation End Date'])) {
        // Handle Excel serial number dates
        const excelDate = updatedRow['Probation End Date'];
        const jsDate = excelDateToJSDate(excelDate);
        updatedRow['Probation End Date'] = formatDate(jsDate);
      } else {
        // Fallback for Date object or other formats
        const parsedDate = new Date(updatedRow['Probation End Date']);
        updatedRow['Probation End Date'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
      }
    
    // Handle Driving license expiry
    // if (typeof updatedRow['Driving license expiry'] === 'string' && isNaN(Date.parse(updatedRow['Driving license expiry']))) {
    //   updatedRow['Driving license expiry'] = '1900-01-01';
    // } else if (!isNaN(updatedRow['Driving license expiry'])) {
    //   const excelDate = updatedRow['Driving license expiry'];
    //   const jsDate = excelDateToJSDate(excelDate);
    //   updatedRow['Driving license expiry'] = formatDate(jsDate);
    // } else {
    //   const parsedDate = new Date(updatedRow['Driving license expiry']);
    //   updatedRow['Driving license expiry'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
    // }
    
    if (typeof updatedRow['Driving license expiry'] === 'string') {
      if (isNaN(Date.parse(updatedRow['Driving license expiry']))) {
        updatedRow['Driving license expiry'] = '1900-01-01';
      } else {
        // Parse manually entered date in MM-DD-YYYY as UTC
        const parsedDate = parseDateAsUTC(updatedRow['Driving license expiry']);
        updatedRow['Driving license expiry'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
      }
    } else if (!isNaN(updatedRow['Driving license expiry'])) {
      // Handle Excel serial number dates
      const excelDate = updatedRow['Driving license expiry'];
      const jsDate = excelDateToJSDate(excelDate);
      updatedRow['Driving license expiry'] = formatDate(jsDate);
    } else {
      // Fallback for Date object or other formats
      const parsedDate = new Date(updatedRow['Driving license expiry']);
      updatedRow['Driving license expiry'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
    }
    
      // Check Driving License
      if (updatedRow['Driving License'] !== 'Valid') {
        updatedRow['Driving License'] = false;
      }
    
      // Check Employee Wages Type
      if (!employeeWagesType.includes(updatedRow['Employee Wages Type'])) {
        updatedRow['Employee Wages Type'] = null;
      }
    
      // Check Clock In/Out
      if (updatedRow['Clock in / out'] !== 'Yes') {
        updatedRow['Clock in / out'] = false;
      }
    
      if (hasError) return null;
    
      return updatedRow;
    });
    
    // Filter out rows that are null (those with email errors)
    const filteredRows = updatedRows.filter((row) => row !== null);
    
    // Create the API payload
    const payload = {
      rows: filteredRows,
    };
    
    const token = localStorage.getItem('jwtToken');
    
    if (!token) {
      // If there's no token, redirect to login page
      setLoading(true);  
      navigate('/login', { state: { message: 'Session expired, please login again.' } });
      return;
    }
    
    const isValidDate = (dateString) => {
      if (!dateString || dateString === 'None') return false; 
      const parsedDate = Date.parse(dateString);
      return !isNaN(parsedDate); // Check if it's a valid date
    };
    
    const formatDateToYYYYMMDD = (dateString) => {
      const date = parseDateAsUTC(dateString); 
    
      if (isNaN(date.getTime())) return '1900-01-01';
    
      return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}`;
    };
    
    const isValidNANPPhone = (phone) => {
    
      const hasInvalidCharacters = phone.match(/[^+\d\s]/);
      if (hasInvalidCharacters) {
        return false;
      }
    
      if (phone.startsWith('+') && !phone.startsWith('+1')) {
        return false;
      }
    
      const countPlus = (phone.match(/\+/g) || []).length;
      if (countPlus > 1) {
        return false;
      }
    
      const cleanedPhone = phone.replace(/[\+\s]/g, '');
    
      const normalizedPhone = cleanedPhone.startsWith('1') ? cleanedPhone : `1${cleanedPhone}`;
    
      if (normalizedPhone.length !== 11) {
        return false;
      }
    
      const areaCode = normalizedPhone.substring(1, 4);
      if (areaCode[0] === '1') {
        return false;
      }
    
      return true;
    };
    
    const normalizePhoneNumber = (phone) => {
      if (!phone) return null;
      const cleanedPhone = phone.replace(/\D/g, ''); // Remove non-digits
      if (cleanedPhone.startsWith('1')) {
        return cleanedPhone; // Already has country code
      }
      return `1${cleanedPhone}`; // Append country code
    };
    
    const apiPayload = payload.rows
      .filter((row) => {
        const phoneValue = row['Phone'] ? row['Phone'].toString().trim() : null;
        const isInvalidPhone = !phoneValue || !isValidNANPPhone(phoneValue);
        return !isInvalidPhone;
      })
      .map((row) => {
    
      const hireDate = row["Hire Date"];
      const dateOfBirth = row['Date of Birth'];
      const probationEndDate = row['Probation End Date'];
      const drivingLicenseExpiry = row['Driving license expiry'];
    
      // Convert to YYYY-MM-DD format or '1900-01-01' if invalid
      const validHireDate = isValidDate(hireDate) ? formatDateToYYYYMMDD(hireDate) : '1900-01-01';
      const validDateOfBirth = isValidDate(dateOfBirth) ? formatDateToYYYYMMDD(dateOfBirth) : '1900-01-01';
      const validProbationEndDate = isValidDate(probationEndDate) ? formatDateToYYYYMMDD(probationEndDate) : '1900-01-01';
      const validDrivingLicenseExpiry = isValidDate(drivingLicenseExpiry) ? formatDateToYYYYMMDD(drivingLicenseExpiry) : '1900-01-01';
    
      const departmentID = (() => {
        const departmentValue = row['Departments'];
    
        // Check if the department is a number
        const departmentIsNumber = !isNaN(departmentValue);
    
        if (departmentIsNumber) {
          return departmentValue; 
        } else {
          const matchingDepartment = departmentOptions.find(dep => dep.value === departmentValue);
          
          return matchingDepartment ? matchingDepartment.key : 0;
        }
    })();      
        const phoneValue = row['Phone'] ? row['Phone'].toString().trim() : null;
        const isInvalidPhone = !phoneValue || !isValidNANPPhone(phoneValue);
    
      return {
        isActive: true,
        employeeID: 0,
        firstName: row["First Name"] || null,
        lastName: row["Last Name"] || null,
        email: row['Email'] || null,  
        phoneNumbers: [{
          phoneNo: isInvalidPhone ? null : normalizePhoneNumber(phoneValue),
          isPrimary: !isInvalidPhone,
        }],   
        companyID: 0,
        userID: 0,
        position: row.Role || null,
        title: null,
        dateOfBirth: validDateOfBirth,
        referredBy: row["Referred By"] || null,
        address: row["Address"] || null,
        city: row.City || null,
        stateProvince: row["State/Province"] || null,
        postalCode: row["Postal Code"] || null,
        country: row.Country || null,
        emergencyContactName: row['Emergency Contact Name'] || null,
        emergencyContactRelationship: row['Emergency Contact Relationship'] || null,
        emergencyContactPhone: row['Emergency Contact Phone Number'] || null,
        hireDate: validHireDate,
        employmentStatus: row["Employment Status"] || null,
        departmentID: departmentID || 0,
        jobTitle: row['Job Title'] || null,
        probationEndDate: validProbationEndDate,
        drivingLicenseValid: row['Driving License'] || false,
        drivingLicenseExpiryDate: validDrivingLicenseExpiry,
        wageAmount: row['Employee Wages Amount'] || 0,
        wageType: row['Employee Wages Type'] || null,
        clockInOutRequired: row['Clock in / out'] || false,
      };
    });
    
    console.log("API Payload" + JSON.stringify(apiPayload))
    
      setLoading(true);
    
      try {
    
        const response = await fetch(`${dev_baseUrl}/Employee/save`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(apiPayload),            
        });
    
        if (response.status === 400) {
          // Handle validation error
          const errorResponse = await response.json();
          console.error('Validation Error:', errorResponse);
    
          // Extract error details
          const validationErrors = errorResponse.errors || {};
          const errorMessages = Object.keys(validationErrors).map((key) => {
            const errorList = validationErrors[key].join(', ');
            return `${key}: ${errorList}`;
          });
    
          // setErrorDetails(errorMessages);
          setMessage('Validation errors occurred. Please check your input.');
          return;
        }
    
        if (response.status === 401) {
          // Token is invalid or expired, redirect to login
          navigate('/login', { state: { message: 'Session expired, please login again.' } });
          return;
        }
        
        if (!response.ok) {
          const errorMessage = `Error ${response.status}: ${response.statusText}`;
          console.error(errorMessage);
          setMessage('Failed to save employee data. Please try again.');
        }
    
        const result = await response.json();
        console.log("API Response:", result);
    
        if (result.isError) {
          const failureMessages = result.result
                .filter(item => item.failureReason) 
                .map(item => `${item.firstName} ${item.lastName}: ${item.failureReason}`); 
    
            if (failureMessages.length > 0) {
              const errorMessagesWithIds = result.result.map((row, index) => ({
                ...row,
                id: index, 
              }));
            
              setErrorMessages(errorMessagesWithIds);
              setOpenErrorListDlg(true); 
              return;
                
            }
          
        } else {
          sessionStorage.setItem('myStep', 3);
          setSuccessMessages(result?.message || 'All employees saved successfully.');
          setOpenSuccessListDlg(true);
        }
    
      } catch (error) {
        console.error("Error:", error);
        setMessage('An error occurred while importing data. Please try again.');
      } finally {
        setLoading(false); 
      }
    
    } else {
      
      const handleDepartmentChange = (event, params) => {
        const value = event.target.value;
        const selectedDepartment = departmentOptions.find(dep => dep.value === value);
      
        if (selectedDepartment) {
          // Update cell value with department key
          params.api.setEditCellValue({ id: params.id, field: 'Department', value: selectedDepartment.key }, event);
        } else {
          console.error("Selected department is invalid.");
        }
      
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === params.id ? { ...row, departmentID: selectedDepartment?.key || null } : row
          )
        );
      };
    
      const allMappedOrIgnored = columnNamesFromFile.every(
          (columnName) => mappingState[columnName]?.confirmed || mappingState[columnName]?.ignored
        );
        
        if (!allMappedOrIgnored) {
          setMessage('Please confirm mapping or ignore all columns before continuing.');
          return;
        }
    
        const requiredFields = ["First Name", "Last Name", "Email", "Phone"];
        const isMappingComplete = requiredFields.every(field =>
          Object.values(mappingState).some(mapping => mapping.mappedValue === field && mapping.confirmed)
        );
    
        if (!isMappingComplete) {
          setMessage('Please map all the required fields: First Name, Last Name, Email, and Phone before proceeding.');
          return;
        }
    
        const mappedData = fileData.map((row, rowIndex) => {
          const mappedRow = {};
    
          const isRowEmpty = Object.values(row).every((value) => !value);
          if (isRowEmpty) {
            return null; // Skip empty rows
          }
        
          for (const columnName in row) {
            if (mappingState[columnName]?.confirmed) {
              const mappedField = mappingState[columnName].mappedValue;
              mappedRow[mappedField] = row[columnName];
            }
          }
        
          return { id: rowIndex.toString(), ...mappedRow };
        }).filter(row => row !== null); // Filter out null rows
    
        setMyData(mappedData);
      
    // ===========================================================
    
    const Rows = mappedData.map((row, index) => ({
      id: index.toString(),
      ...row,
    }));
      
    setRows(Rows);
    
    const columns = Object.keys(mappedData[0] || {}).map(key => {
      if (key === 'Role') {
        return {
          field: key,
          headerName: key,
          flex: 1,
          minWidth: 100,
          editable: true,
          renderEditCell: (params) => (
            <Select
              value={params.value || ''} 
              onChange={(event) => {
                const value = event.target.value;
              
                params.api.setEditCellValue({ id: params.id, field: key, value }, event);
    
                setMyData((prevData) =>
                  prevData.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
    
                // Update rows state directly here
                setRows((prevRows) =>
                  prevRows.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
              }}
              renderValue={(selected) => selected || 'None'} 
              sx={{
                m:0,
                p: 0
              }}
            >
              {rolesOptions.map(role => (
                <MenuItem key={role} value={role}>
                  <ListItemText primary={role} />
                </MenuItem>
              ))}
              <MenuItem key="none" value="">
                <ListItemText primary="None" />
              </MenuItem>
            </Select>
          ),
          renderCell: (params) => {
            const isValidRole = rolesOptions.includes(params.value);
            const displayValue = isValidRole ? params.value : 'None';
            return (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                  height: '100%',
                  width: '100%'
                }}
              >
                <Box sx={{
                  backgroundColor: isValidRole ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
                  padding: isValidRole ? '0px' : '8px',
                  borderRadius: '4px',
                  width: '100%'
                }}>
                  <Tooltip
                    title={isValidRole ? '' : `${params.value} is not a valid value. Please select valid value from dropdown`}
                    placement="bottom"
                    arrow
                  >
                    <Typography variant="body2">
                      {displayValue}
                    </Typography>
                  </Tooltip>
                </Box>
              </Box>
            );
          },
        };
      } else if (key === 'Employment Status') {
        return {
          field: key,
          headerName: key,
          flex: 1,
          minWidth: 100,
          editable: true,
          renderEditCell: (params) => (
            <Select
              value={params.value || ''} 
              onChange={(event) => {
                const value = event.target.value;
              
                params.api.setEditCellValue({ id: params.id, field: key, value }, event);
    
                setMyData((prevData) =>
                  prevData.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
    
                // Update rows state directly here
                setRows((prevRows) =>
                  prevRows.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
              }}
              renderValue={(selected) => selected || 'None'} 
              sx={{
                m:0,
                p: 0
              }}
            >
              {employeeStatusOptions.map(status => (
                <MenuItem key={status} value={status}>
                  <ListItemText primary={status} />
                </MenuItem>
              ))}
              <MenuItem key="none" value="">
                <ListItemText primary="None" />
              </MenuItem>
            </Select>
          ),
          renderCell: (params) => {
            const isValidStatus = employeeStatusOptions.includes(params.value);
            const displayValue = isValidStatus ? params.value : 'None';
            return (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                  height: '100%',
                  width: '100%'
                }}
              >
                <Box sx={{
                  backgroundColor: isValidStatus ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
                  padding: isValidStatus ? '0px' : '8px',
                  borderRadius: '4px',
                  width: '100%'
                }}>
                  <Tooltip
                    title={isValidStatus ? '' : `${params.value} is not a valid value. Please select valid value from dropdown`}
                    placement="bottom"
                    arrow
                  >
                    <Typography variant="body2">
                      {displayValue}
                    </Typography>
                  </Tooltip>
                </Box>
              </Box>
            );
          },
        };
      } else if (key === 'Departments') {
        return {
          field: key,
          headerName: key,
          flex: 1,
          minWidth: 100,
          editable: true,
          renderEditCell: (params) => (
            <Select
              // Ensure the dropdown shows the department's value (name) by finding it using the department key
              value={
                departments.find(dep => dep.key === params.value)?.value || ''
              }
              onChange={(event) => {
                const selectedValue = event.target.value;
                const selectedDepartment = departments.find(dep => dep.value === selectedValue); // Find department by value
                const departmentKey = selectedDepartment ? selectedDepartment.key : null; // Get the corresponding key
      
                // Log for debugging
                console.log("Selected department key:", departmentKey);
      
                // Set the department key as the value in the DataGrid cell
                params.api.setEditCellValue({ id: params.id, field: key, value: departmentKey }, event);
                
                setMyData((prevData) =>
                  prevData.map((row) =>
                    row.id === params.id ? { ...row, Departments: departmentKey } : row
                  )
                );
    
                // Update the rows state with the key
                setRows((prevRows) =>
                  prevRows.map((row) =>
                    row.id === params.id ? { ...row, Departments: departmentKey } : row
                  )
                );
              }}
              renderValue={(selected) => selected || 'None'} // Show 'None' if no selection
            >
              {departments.map(option => (
                <MenuItem key={option.key} value={option.value}>
                  <ListItemText primary={option.value} />
                </MenuItem>
              ))}
              <MenuItem key="none" value="">
                <ListItemText primary="None" />
              </MenuItem>
            </Select>
          ),
          
          renderCell: (params) => {
            // Match by the department's value to display the correct name
            const department = departments.find(dep => dep.value === params.value || dep.key === params.value);
      
            // Check if the department exists in the options
            const isValidDepartment = !!department;
      
            // Show the department's value if valid, otherwise show "None"
            const displayDepartmentValue = isValidDepartment ? department.value : 'None';
            
            return (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                  height: '100%',
                  width: '100%'
                }}
              >
                <Box sx={{
                  backgroundColor: isValidDepartment ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
                  padding: isValidDepartment ? '0px' : '8px',
                  borderRadius: '4px',
                  width: '100%'
                }}>
                  <Tooltip
                    title={isValidDepartment ? '' : `${params.value} is not a valid department. Please select from dropdown.`}
                    placement="bottom"
                    arrow
                  >
                    <Typography variant="body2">{displayDepartmentValue}</Typography>
                  </Tooltip>
                </Box>
              </Box>
            );
          },
        };
      } else if (key === 'Status') {
        return {
          field: key,
          headerName: key,
          flex: 1,
          minWidth: 100,
          editable: true,
          renderEditCell: (params) => (
            <Select
              value={params.value || ''} // Ensure value is a string
              onChange={(event) => {
                const value = event.target.value;
                // Use params.api.setEditCellValue to update the cell value
                params.api.setEditCellValue({ id: params.id, field: key, value }, event);
    
                setMyData((prevData) =>
                  prevData.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
    
                // Update rows state directly here
                setRows((prevRows) =>
                  prevRows.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
              }}
              renderValue={(selected) => selected || 'None'} // Show 'None' if no selection
            >
              {statusOptions.map(status => (
                <MenuItem key={status} value={status}>
                  <ListItemText primary={status} />
                </MenuItem>
              ))}
              <MenuItem key="none" value="">
                <ListItemText primary="None" />
              </MenuItem>
            </Select>
          ),
          renderCell: (params) => {
            const isValidStatus = statusOptions.includes(params.value);
            const displayStatusValue = isValidStatus ? params.value : 'None';
            return (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                  height: '100%',
                  width: '100%'
                }}
              >
                <Box sx={{
                  backgroundColor: isValidStatus ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
                  padding: isValidStatus ? '0px' : '8px',
                  borderRadius: '4px',
                  width: '100%'
                }}>
                  <Tooltip
                    title={isValidStatus ? '' : `${params.value} is not a valid value. Please select valid value from dropdown`}
                    placement="bottom"
                    arrow
                  >
                    <Typography variant="body2">
                      {displayStatusValue}
                    </Typography>
                  </Tooltip>
                </Box>
              </Box>
            );
          },
        };
      } else if (key === 'Email') {
        return {
          field: key,
          headerName: key,
          flex: 1,
          minWidth: 100,
          editable: true,
          renderEditCell: (params) => (
            <TextField
              value={params.value || ''}
              onChange={(event) => {
                const value = event.target.value;
      
                // Update the grid's internal state immediately
                params.api.setEditCellValue({ id: params.id, field: key, value }, event);
      
                // Perform validation for the email
                const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
                
                setMyData((prevData) =>
                  prevData.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
    
                // Update component's rows state directly, regardless of validation
                setRows((prevRows) =>
                  prevRows.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
      
                // Optionally, log or handle the invalid email scenario 
                if (!isValidEmail && value !== '') {
                  console.warn('Invalid email format');
                }
              }}
              variant="outlined"
              error={!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(params.value) && params.value !== ''}
              helperText={
                !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(params.value) && params.value !== ''
                  ? 'Invalid email format'
                  : ''
              }
            />
          ),
          renderCell: (params) => {
            const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(params.value);
            params.value = params.value.length === 0 ? 'none' : params.value;
            return (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                  height: '100%',
                  width: '100%'
                }}
              >
                <Box sx={{
                  backgroundColor: isValidEmail ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
                  padding: isValidEmail ? '0px' : '8px',
                  borderRadius: '4px',
                  width: '100%'
                }}>
                  <Tooltip
                    title={
                      !isValidEmail
                        ? 'You can start your import, but this value will be skipped. Try putting it in name@example.com'
                        : ''
                    }
                    placement="bottom"
                    arrow
                  >
                    <Typography variant="body2">{params.value}</Typography>
                  </Tooltip>
                </Box>
              </Box>
            );
          },
        };
      } else if (key === 'Phone') {
    
        const isValidNANPPhone = (phone) => {
          const hasInvalidCharacters = phone.match(/[^+\d\s]/);
          if (hasInvalidCharacters) {
            return false;
          }
        
          if (phone.startsWith('+') && !phone.startsWith('+1')) {
            return false;
          }
        
          const countPlus = (phone.match(/\+/g) || []).length;
          if (countPlus > 1) {
            return false;
          }
        
          const cleanedPhone = phone.replace(/[\+\s]/g, '');
          const normalizedPhone = cleanedPhone.startsWith('1') ? cleanedPhone : `1${cleanedPhone}`;
        
          if (normalizedPhone.length !== 11) {
            return false;
          }
        
          const areaCode = normalizedPhone.substring(1, 4);
          if (areaCode[0] === '1') {
            return false;
          }
          
          return true;
        };
        
        return {
            field: key,
            headerName: 'Phone',
            flex: 1,
            minWidth: 150,
            editable: true,
            renderEditCell: (params) => {
                return (
                    <TextField
                        value={params.value || ''}
                        onChange={(event) => {
                            const value = event.target.value;
      
                            params.api.setEditCellValue({ id: params.id, field: key, value }, event);
                            
                            setMyData((prevData) =>
                              prevData.map((row) =>
                                row.id === params.id ? { ...row, [key]: value } : row
                              )
                            );
      
                            // Update rows state
                            setRows((prevRows) =>
                                prevRows.map((row) =>
                                    row.id === params.id ? { ...row, [key]: value } : row
                                )
                            );                      
                        }}
                        
                    />
                );
            },
            renderCell: (params) => {
              const phoneValue = params.value ? String(params.value) : '';
              const isInvalidPhone = !phoneValue || !isValidNANPPhone(phoneValue);
    
                return (
                    <Box
                        sx={{
                            backgroundColor: isInvalidPhone ? 'rgba(227, 0, 0, 0.1)' : 'transparent',
                            padding: '9px',
                            borderRadius: '4px',
                            position: 'relative',
                        }}
                    >
                        <Tooltip
                            title={isInvalidPhone ? 'This employee will be skipped. Invalid phone number.' : ''}
                            placement="bottom"
                            arrow
                        >
                            <Typography variant="body2">
                                {params.value || 'None'}
                            </Typography>
                        </Tooltip>
                    </Box>
                );
            },
        };
      } else if (key === 'First Name') {
        return {
          field: key,
          headerName: key,
          flex: 1,
          minWidth: 100,
          editable: true,
          renderEditCell: (params) => (
            <TextField
              value={params.value || ''}
              onChange={(event) => {
                const value = event.target.value;
      
                params.api.setEditCellValue({ id: params.id, field: key, value }, event);
      
                // Perform validation for the name
                const isValidName = value && value.length > 1 && value !=='None';
                
                setMyData((prevData) =>
                  prevData.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
    
                // Update component's rows state directly, regardless of validation
                setRows((prevRows) =>
                  prevRows.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                ); 
    
                if (!isValidName && value !== '') {
                  console.warn('Invalid name');
                }
              }}
              variant="outlined"
              error={params.value !== ''}
              helperText={
                params.value !== ''
                  ? 'Invalid name'
                  : ''
              }
            />
          ),
          renderCell: (params) => {
            const isValidName = params.value && params.value.length > 1 && params.value !== 'None';
            params.value = params.value.length === 0 ? 'None' : params.value;
            return (
              <Box
                sx={{
                  backgroundColor: isValidName ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
                  padding: '9px',
                  borderRadius: '4px',
                  position: 'relative',
                }}
              >
                <Tooltip
                  title={
                    isValidName
                      ? ''
                      : 'You can start your import, but this employee will be skipped. Try putting it a valid name'
                  }
                  placement="bottom"
                  arrow
                >
                  <Typography variant="body2">{params.value}</Typography>
                </Tooltip>
              </Box>
            );
          },
        };
      } else if (key === 'Last Name') {
        return {
          field: key,
          headerName: key,
          flex: 1,
          minWidth: 100,
          editable: true,
          renderEditCell: (params) => (
            <TextField
              value={params.value || ''}
              onChange={(event) => {
                const value = event.target.value;
      
                params.api.setEditCellValue({ id: params.id, field: key, value }, event);
      
                // Perform validation for the name
                const isValidName = value && value.length > 1 && value !=='None';
                
                setMyData((prevData) =>
                  prevData.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
    
                // Update component's rows state directly, regardless of validation
                setRows((prevRows) =>
                  prevRows.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
                
                if (!isValidName && value !== '') {
                  console.warn('Invalid name');
                }
              }}
              variant="outlined"
              error={params.value !== ''}
              helperText={
                params.value !== ''
                  ? 'Invalid name'
                  : ''
              }
            />
          ),
          renderCell: (params) => {
            const isValidName = params.value && params.value.length > 1 && params.value !== 'None';
            params.value = params.value.length === 0 ? 'None' : params.value;
            return (
              <Box
                sx={{
                  backgroundColor: isValidName ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
                  padding: '9px',
                  borderRadius: '4px',
                  position: 'relative',
                }}
              >
                <Tooltip
                  title={
                    isValidName
                      ? ''
                      : 'You can start your import, but this employee will be skipped. Try putting it a valid name'
                  }
                  placement="bottom"
                  arrow
                >
                  <Typography variant="body2">{params.value}</Typography>
                </Tooltip>
              </Box>
            );
          },
        };
      } else if (key === 'Hire Date') {
        return {
          field: key,
          headerName: key,
          flex: 1,
          minWidth: 100,
          editable: true,
          renderEditCell: (params) => (
            <TextField
              value={params.value || ''}
              onChange={(event) => {
                const value = event.target.value;
    
                // Update the grid's internal state
                params.api.setEditCellValue({ id: params.id, field: key, value }, event);
    
                setMyData((prevData) =>
                  prevData.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
    
                // Update component's rows state
                setRows((prevRows) =>
                  prevRows.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
              }}
              placeholder="MM-DD-YYYY"
              variant="outlined"
              error={!/^\d{2}-\d{2}-\d{4}$/.test(params.value)}
              helperText={!/^\d{2}-\d{2}-\d{4}$/.test(params.value) ? 'Invalid date format' : ''}
            />
          ),
          renderCell: (params) => {
            const excelDate = params.value;
            const isNumber = !isNaN(excelDate);
            const jsDate = isNumber ? excelDateToJSDate(excelDate) : parseDateAsUTC(excelDate); // Convert if it's a number
            const displayDate = formatDate(jsDate); // Format to MM-DD-YYYY
          
            // Date validation (MM-DD-YYYY format)
            const isValidDate = /^\d{2}-\d{2}-\d{4}$/.test(displayDate);
          
            return (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                  height: '100%',
                  width: '100%'
                }}
              >
                <Box sx={{
                  backgroundColor: isValidDate ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
                  padding: isValidDate ? '0px' : '8px',
                  borderRadius: '4px',
                  width: '100%'
                }}>
                  <Tooltip
                    title={
                      isValidDate
                        ? ''
                        : 'Invalid date format. Please use format MM-DD-YYYY.'
                    }
                    placement="bottom"
                    arrow
                  >
                    <Typography variant="body2">{displayDate}</Typography>
                  </Tooltip>
                </Box>
              </Box>
            );
          },      
        };
      } else if (key === 'Date of Birth') {
        return {
          field: key,
          headerName: key,
          flex: 1,
          minWidth: 100,
          editable: true,
          renderEditCell: (params) => (
            <TextField
              value={params.value || ''}
              onChange={(event) => {
                const value = event.target.value;
    
                // Update the grid's internal state
                params.api.setEditCellValue({ id: params.id, field: key, value }, event);
    
                setMyData((prevData) =>
                  prevData.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
    
                // Update component's rows state
                setRows((prevRows) =>
                  prevRows.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
              }}
              placeholder="MM-DD-YYYY"
              variant="outlined"
              error={!/^\d{2}-\d{2}-\d{4}$/.test(params.value)}
              helperText={!/^\d{2}-\d{2}-\d{4}$/.test(params.value) ? 'Invalid date format' : ''}
            />
          ),
          renderCell: (params) => {
            const excelDate = params.value;
            const isNumber = !isNaN(excelDate);
            const jsDate = isNumber ? excelDateToJSDate(excelDate) : parseDateAsUTC(excelDate); // Convert if it's a number
            const displayDate = formatDate(jsDate); // Format to MM-DD-YYYY
          
            // Date validation (MM-DD-YYYY format)
            const isValidDate = /^\d{2}-\d{2}-\d{4}$/.test(displayDate);
          
            return (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                  height: '100%',
                  width: '100%'
                }}
              >
                <Box sx={{
                  backgroundColor: isValidDate ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
                  padding: isValidDate ? '0px' : '8px',
                  borderRadius: '4px',
                  width: '100%'
                }}>
                  <Tooltip
                    title={
                      isValidDate
                        ? ''
                        : 'Invalid date format. Please use format MM-DD-YYYY.'
                    }
                    placement="bottom"
                    arrow
                  >
                    <Typography variant="body2">{displayDate}</Typography>
                  </Tooltip>
                </Box>
              </Box>
            );
          },      
        };
      } else if (key === 'Probation End Date') {
        return {
          field: key,
          headerName: key,
          flex: 1,
          minWidth: 100,
          editable: true,
          renderEditCell: (params) => (
            <TextField
              value={params.value || ''}
              onChange={(event) => {
                const value = event.target.value;
    
                // Update the grid's internal state
                params.api.setEditCellValue({ id: params.id, field: key, value }, event);
    
                setMyData((prevData) =>
                  prevData.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
    
                // Update component's rows state
                setRows((prevRows) =>
                  prevRows.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
              }}
              placeholder="MM-DD-YYYY"
              variant="outlined"
              error={!/^\d{2}-\d{2}-\d{4}$/.test(params.value)}
              helperText={!/^\d{2}-\d{2}-\d{4}$/.test(params.value) ? 'Invalid date format' : ''}
            />
          ),
          renderCell: (params) => {
            const excelDate = params.value;
            const isNumber = !isNaN(excelDate);
            const jsDate = isNumber ? excelDateToJSDate(excelDate) : parseDateAsUTC(excelDate); // Convert if it's a number
            const displayDate = formatDate(jsDate); // Format to MM-DD-YYYY
          
            // Date validation (MM-DD-YYYY format)
            const isValidDate = /^\d{2}-\d{2}-\d{4}$/.test(displayDate);
          
            return (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                  height: '100%',
                  width: '100%'
                }}
              >
                <Box sx={{
                  backgroundColor: isValidDate ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
                  padding: isValidDate ? '0px' : '8px',
                  borderRadius: '4px',
                  width: '100%'
                }}>
                  <Tooltip
                    title={
                      isValidDate
                        ? ''
                        : 'Invalid date format. Please use format MM-DD-YYYY.'
                    }
                    placement="bottom"
                    arrow
                  >
                    <Typography variant="body2">{displayDate}</Typography>
                  </Tooltip>
                </Box>
              </Box>
            );
          },      
        };
      } else if (key === 'Driving license expiry') {
        return {
          field: key,
          headerName: key,
          flex: 1,
          minWidth: 100,
          editable: true,
          renderEditCell: (params) => (
            <TextField
              value={params.value || ''}
              onChange={(event) => {
                const value = event.target.value;
    
                // Update the grid's internal state
                params.api.setEditCellValue({ id: params.id, field: key, value }, event);
    
                setMyData((prevData) =>
                  prevData.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
    
                // Update component's rows state
                setRows((prevRows) =>
                  prevRows.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
              }}
              placeholder="MM-DD-YYYY"
              variant="outlined"
              error={!/^\d{2}-\d{2}-\d{4}$/.test(params.value)}
              helperText={!/^\d{2}-\d{2}-\d{4}$/.test(params.value) ? 'Invalid date format' : ''}
            />
          ),
          renderCell: (params) => {
            const excelDate = params.value;
            const isNumber = !isNaN(excelDate);
            const jsDate = isNumber ? excelDateToJSDate(excelDate) : parseDateAsUTC(excelDate); // Convert if it's a number
            const displayDate = formatDate(jsDate); // Format to MM-DD-YYYY
          
            // Date validation (MM-DD-YYYY format)
            const isValidDate = /^\d{2}-\d{2}-\d{4}$/.test(displayDate);
          
            return (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                  height: '100%',
                  width: '100%'
                }}
              >
                <Box sx={{
                  backgroundColor: isValidDate ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
                  padding: isValidDate ? '0px' : '8px',
                  borderRadius: '4px',
                  width: '100%'
                }}>
                  <Tooltip
                    title={
                      isValidDate
                        ? ''
                        : 'Invalid date format. Please use format MM-DD-YYYY.'
                    }
                    placement="bottom"
                    arrow
                  >
                    <Typography variant="body2">{displayDate}</Typography>
                  </Tooltip>
                </Box>
              </Box>
            );
          },      
        };
      } else if (key === 'Employee Wages Type') {
        return {
          field: key,
          headerName: 'Employee Wages Type',
          flex: 1,
          minWidth: 150,
          editable: true,
          renderEditCell: (params) => (
            <Select
              value={params.value || ''}
              onChange={(event) => {
                const value = event.target.value;
                const isValid = value === 'Salaried' || value === 'Hourly';
    
                if (!isValid) {
                  return; // Do not update invalid value
                }
      
                // Update Employee Wages Type
                params.api.setEditCellValue({ id: params.id, field: key, value }, event);
      
                setMyData((prevData) =>
                  prevData.map((row) =>
                    row.id === params.id
                      ? { ...row, [key]: value, 'Employee Wages Amount': 0 }
                      : row
                  )
                );
      
                // Update rows state
                setRows((prevRows) =>
                  prevRows.map((row) =>
                    row.id === params.id
                      ? { ...row, [key]: value, 'Employee Wages Amount': 0 }
                      : row
                  )
                );
              }}
              renderValue={(selected) => selected || 'None'}
              sx={{ m: 0, p: 0 }}
            >
              <MenuItem value="Salaried">
                <ListItemText primary="Salaried" />
              </MenuItem>
              <MenuItem value="Hourly">
                <ListItemText primary="Hourly" />
              </MenuItem>
              <MenuItem key="none" value="">
                <ListItemText primary="None" />
              </MenuItem>
            </Select>
          ),
          renderCell: (params) => {
    
            const isValidStatus = params.value === 'Salaried' || params.value === 'Hourly';
            const displayStatusValue = isValidStatus ? params.value : 'None';
    
            return (
              <Box
                sx={{
                  backgroundColor: isValidStatus ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
                  padding: isValidStatus ? '0px' : '8px',
                  borderRadius: '4px',
                  width: '100%',
                }}
              >
                <Tooltip
                  title={
                    isValidStatus
                      ? ''
                      : `${params.value} is not a valid value. Please select a valid value from the dropdown.`
                  }
                  placement="bottom"
                  arrow
                >
                  <Typography variant="body2">{displayStatusValue}</Typography>
                </Tooltip>
              </Box>
          )
        },
        };
      } else if (key === 'Employee Wages Amount') {
        return {
          field: key,
          headerName: 'Employee Wages Amount',
          flex: 1,
          minWidth: 150,
          editable: true,
          renderEditCell: (params) => (
            <TextField
              value={params.value || ''}
              type="number"
              onChange={(event) => {
                const value = Number(event.target.value);
      
                // Update Employee Wages Amount
                params.api.setEditCellValue({ id: params.id, field: key, value }, event);
      
                setMyData((prevData) =>
                  prevData.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
      
                // Update rows state
                setRows((prevRows) =>
                  prevRows.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
              }}
              variant="outlined"
            />
          ),
          renderCell: (params) => (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                height: '100%',
                width: '100%',
              }}
            >
              <Typography variant="body2">
                {params.value || '0'}
              </Typography>
            </Box>
          ),
        };
      } else {
        return {
          field: key,
          headerName: key,
          flex: 1,
          minWidth: 100,
          editable: true,
          renderEditCell: (params) => (
            <TextField
              value={params.value || ''}
              onChange={(event) => {
                const value = event.target.value;
                
                // Update the grid's internal state
                params.api.setEditCellValue({ id: params.id, field: key, value }, event);
    
                setMyData((prevData) =>
                  prevData.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
    
                // Update component's rows state
                setRows((prevRows) =>
                  prevRows.map((row) =>
                    row.id === params.id ? { ...row, [key]: value } : row
                  )
                );
              }}
              variant="outlined"
            />
          ),
          renderCell: (params) => (
            <Box
              sx={{
                display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                  height: '100%',
                  width: '100%'
              }}
            >
              <Box sx={{
                  backgroundColor: 'transparent',
                  padding: '0px',
                  borderRadius: '4px',
                  width: '100%'
                }}>
                <Typography variant="body2" sx={{ color: 'text.primary' }}>
                  {params.value}
                </Typography>
                </Box>
            </Box>
          ),
        };
      }
    });
    
    
    const filteredColumns = columns.filter(column => column.field !== 'id');
    setColumns(filteredColumns);
    
    // ===========================================================
    
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    
     }
    
    };

    const filteredRows = (rows || []).filter((row) =>
        Object.values(row).some((value) =>
            value && value.toString().toLowerCase().includes(searchText.toLowerCase())
        )
    );

    if (preLoading) {
        return (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
            }}
          >
            <CircularProgress />
            <Typography sx={{ ml: 2 }}>Loading...</Typography>
          </Box>
        );
      }

      const getStepContent = step => {
        switch (step) {
          case 0:
            return (
              <Fragment>
                <Grid container spacing={5} sx={{mt: 1}}>
                   {displayBanner && (
                                                <Grid item xs={12}>
                                                  <Box
                                                    sx={{
                                                      display: "inline-flex",
                                                      justifyContent: "space-between",
                                                      alignItems: "center",
                                                      backgroundColor: "rgb(35, 162, 109, 0.1)",
                                                      border: "1px solid",
                                                      borderColor: "success.main",
                                                      borderRadius: "12px",
                                                      py: 1,
                                                      px: 3,
                                                      gap: 1,
                                                    }}
                                                  >
                                                    <Icon icon="tabler:info-circle" />
                                                    <Typography
                                                      variant="h6"
                                                      fontWeight="500"
                                                      sx={{ ml: 2, mr: 3 }}
                                                    >
                                                      These fields are editable! -You can use your AI Assistant
                                                      to do this part later.
                                                    </Typography>
                                                  
                                                      <IconButton onClick={() => setDisplayBanner(false)}>
                                                        <Icon icon="tabler:x" />
                                                      </IconButton>
                                                    
                                                  </Box>
                                                </Grid>
                                              )}
                  { !alertIsDismissed && (
                    <Grid item xs={12}>
                      <Box sx=
                        {{
                          display: 'inline-flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          backgroundColor: 'rgba(255, 159, 67, 0.16)',
                          border: '1px solid', 
                          borderColor: 'warning.main', 
                          borderRadius: '12px', 
                          py: 1,
                          px: 3,
                          gap: 2
                        }}>
                        <Icon icon="tabler:alert-triangle" />
                        <Typography variant='h6' fontWeight='500'>
                          Please ensure the First Name, Last Name, Email, and Phone fields are mapped as they are required to proceed with the next steps.
                        </Typography>
                        <IconButton onClick={handleAlertDismiss} color='warning'>
                          <Icon icon='tabler:x' />
                        </IconButton>
                      </Box>
                    </Grid>
                  ) }
                  <Grid item xs={12} sm={4}>
                    <Typography variant="h5" color='text.secondary' fontWeight='550' gutterBottom>File Source Fields</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                  <Typography variant="h5" color='text.secondary' fontWeight='550' gutterBottom>Cleri Fields</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    {/* Empty grid to align the third column (status buttons) */}
                  </Grid>
                
                  {/* Dropdowns Row */}
                  {columnNamesFromFile.map((columnName, colIndex) => (
                    <Fragment key={colIndex}>
                      <Grid item xs={12} sm={4}>
                        <CustomTextField
                          fullWidth
                          label=''
                          value={columnName}
                          disabled
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <CustomTextField
                          fullWidth
                          select
                          // defaultValue={
                          //   fieldsToRender.includes(columnName) 
                          //     ? columnName 
                          //     : fieldsToRender.some(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
                          //       ? fieldsToRender.find(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
                          //       : 'select'
                          // }
                          value={selectedValues[columnName] || getDefaultValues()[columnName]}
                          label=''
                          onChange={handleSelectChange(columnName)} 
                          error={!!errorState[columnName]} // Apply error if duplicate is detected
                          helperText={errorState[columnName]} // Show helper text if error exists
                          disabled={mappingState[columnName]?.confirmed || mappingState[columnName]?.ignored}
                        >
                          <ListSubheader>Mandatory Fields</ListSubheader>
                          <MenuItem value='select' disabled>Select</MenuItem>
                          {predefinedFields.map((field, index) => (
                            <MenuItem key={index} value={field}>
                              {field}
                            </MenuItem>
                          ))}
                          <ListSubheader>Optional Fields</ListSubheader>
                          {additionalFields.map((field, index) => (
                            <MenuItem key={index} value={field}>
                              {field}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        {mappingState[columnName]?.confirmed ? (
                          <Box sx={{ display: 'flex' }}>
                            <Icon>
                              <CheckCircleIcon sx={{ color: '#1FC16B', height: '17px', width: '17px', my: 'auto', mr: 2 }} />
                            </Icon>
                            <Typography sx={{ fontWeight: 'bold', color: 'success', my: 'auto', mr: 4 }}>Mapping Confirmed</Typography>
                            <Button variant='contained' color='main' onClick={() => handleEditClick(columnName)}>
                              Edit
                            </Button>
                          </Box>
                        ) : mappingState[columnName]?.ignored ? (
                          <Box sx={{ display: 'flex' }}>
                            <Typography sx={{ fontWeight: 'bold', my: 'auto', mr: 4 }}>Ignored</Typography>
                            <Button variant='contained' color='main' onClick={() => handleEditClick(columnName)}>
                              Edit
                            </Button>
                          </Box>
                        ) : (
                          <>
                            <Button
                              variant='contained'
                              sx={{ mr: 4, mb: 2 }}
                              color='main'
                              onClick={() => handleConfirmClick(columnName)}
                              disabled={isConfirmDisabled(columnName)} // Disable based on conditions
                            >
                              Confirm mapping
                            </Button>
                            <Button
                              variant='outlined'
                              color='primary'
                              sx={{ mb: 2 }}
                              onClick={() => handleIgnoreClick(columnName)}
                            >
                              Ignore this column
                            </Button>
                          </>
                        )}
                      </Grid>
                    </Fragment>
                  ))}
                </Grid>
              </Fragment>
    
            )
          case 1:
            return (
              <Fragment>           
            <Box sx={{padding:'10px 20px 20px 20px',boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px', borderRadius:'10px'}}>                          
              <Grid item xs={12} sm={12}>
                <DataGridPro
                  autoHeight
                  pagination
                  rows={filteredRows}
                  rowCount={total}
                  columns={columns}
                  getRowId={(row) => row.id}              
                  sortingMode="server"
                  paginationMode="server"
                  pageSizeOptions={[7, 10, 25, 50]}
                  paginationModel={paginationModel}
                  onSortModelChange={handleSortModel}
                  onPaginationModelChange={setPaginationModel}
                  editMode="cell"
                  // onCellEditCommit={handleEditCellChangeCommitted}
                  slots={{ toolbar: ServerSideToolbar }}
                  slotProps={{
                    baseButton: {
                      size: 'medium',
                      variant: 'tonal',
                    },
                    toolbar: {
                      value: searchValue,
                      clearSearch: () => handleSearch(''),
                      onChange: (event) => handleSearch(event.target.value),
                      valueExists: searchValue !== '',
                    },
                  }}
                  sx={{
                    '& .MuiDataGrid-columnHeaderTitle': {
                      textTransform: 'none', // This will disable the capitalization
                    }
                  }}
                />
              </Grid>
              </Box>
              
            </Fragment>
            )
          default:
            return 'Unknown Step'
        }
      }

    const renderContent = () => {
        return (
            <>
                {message && (
                    <Box mb={2} textAlign="center">
                        <Typography variant="h6" color={message.includes('successfully') ? 'green' : 'red'}>
                            {message.split('\n').map((line, index) => (
                                <div key={index}>{line}</div>
                            ))}
                        </Typography>
                    </Box>
                )}
                <form onSubmit={e => e.preventDefault()} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    {getStepContent(activeStep)}
                    <Grid item xs={12} sx={{ position: 'fixed', bottom: 0, right: 0, width: '100vw', display: 'flex', justifyContent: 'flex-end', py: 4, pr: 10, backgroundColor: 'white', boxShadow: '0 -2px 5px rgba(0,0,0,0.1)' }}>
                        <Button variant='tonal' color='secondary' onClick={handleBack} sx={{ mr: 4 }}
                        // disabled={activeStep === 0}
                        >
                            Back
                        </Button>
                        <Button variant='contained' color='main' onClick={handleNext} disabled={loading} >
                            {loading ? <CircularProgress size={24} /> : (activeStep === steps.length - 1 ? 'Complete Import' : 'Continue')}
                        </Button>
                    </Grid>
                </form>
            </>
        )
    }

    return (
        <BlankLayout>
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '92vh' }}>
                <Card sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                    <CardHeader
                        title={
                            <>
                                <StepperWrapper>
                                    <Stepper
                                        activeStep={activeStep}
                                        connector={
                                            !smallScreen ? <Icon icon={direction === 'ltr' ? 'tabler:chevron-right' : 'tabler:chevron-left'} /> : null
                                        }
                                    >
                                        {steps.map((step, index) => (
                                            <Step key={index}>
                                                <StepLabel StepIconComponent={StepperCustomDot}>
                                                    <div>
                                                    <Typography className='step-title' fontWeight={ index == activeStep ? 'bold !important' : 'normal' }>{step.title}</Typography>
                                                    <Typography className='step-subtitle'>{step.subtitle}</Typography>
                                                    </div>
                                                </StepLabel>
                                            </Step>
                                        ))}
                                    </Stepper>
                                </StepperWrapper>
                                <Divider sx={{ mt: 4 }} />
                            </>
                        }
                    />
                    <CardContent sx={{ flexGrow: 1, overflowY: 'auto' }}>
                        {renderContent()}
                    </CardContent>
                </Card>
            </Box>

            {/* Error List Dialog */}
            <Dialog
            fullWidth
            maxWidth="md"
            open={openErrorListDlg}
            onClose={handleCloseErrorListDlg}
            aria-labelledby="form-dialog-title"
            sx={{
                "& .MuiDialog-paper": {
                maxWidth: '650px', // Custom maxWidth between sm and md
                width: '100%', // Ensures it’s responsive within the set max width
                },
            }}
            >
            <DialogTitle>
                    <Typography variant="h4" fontWeight='bold'>Save Unsuccessful</Typography>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={5}>
                    <Grid item xs={12}>
                        <Typography variant="button">The following employees will be skipped due to the reasons listed below.</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <DataGridPro
                        autoHeight              
                        rows={errorMessages}
                        getRowId={(row) => row.id}
                        columns={errorColumns}           
                        sx={{
                            "& .MuiDataGrid-columnHeaderTitle": {
                            textTransform: "none",
                            fontWeight: 'bold'
                            },
                            maxWidth: '600px'
                        }}
                        />
                    </Grid>
                    </Grid>     
                </DialogContent>
                <DialogActions
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                    className="dialog-actions-dense"
                >
                    <Button variant="contained" color="main" onClick={handleCloseErrorListDlg}>
                    OK
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                fullWidth={true}
                maxWidth="xs"
                open={openSuccessListDlg}
                onClose={handleCloseSuccessListDlg}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle>
                <Typography variant="h4" fontWeight='bold'>Employee Import Success</Typography>
                </DialogTitle>
                <DialogContent>
                <Fragment>          
                    {successMessages}
                </Fragment>
                </DialogContent>
                <DialogActions
                sx={{ display: "flex", justifyContent: "flex-end" }}
                className="dialog-actions-dense"
                >
                <Button variant="contained" color="main" onClick={handleCloseSuccessListDlg}>
                    OK
                </Button>
                </DialogActions>
            </Dialog>
           
        </BlankLayout>
    )
}

export default EmployeeBulkImport